import { render, staticRenderFns } from "./TransferTaskFormModal.vue?vue&type=template&id=3906f354"
import script from "./TransferTaskFormModal.vue?vue&type=script&lang=js"
export * from "./TransferTaskFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports